/**
 * @param  {*} x value
 * @return {boolean} isNull
 *
 * @since 3.0.0
 * @memberOf is
 * @func isNull
 *
 * @example
 *
 *  isNull(null)
 *  //=> true
 *
 *  isNull(undefined)
 *  //=> false
 *  isNull(void 0)
 *  //=> false
 *  isNull({})
 *  //=> false
 *  isNull('')
 *  //=> false
 *  isNull(1)
 *  //=> false
 *
 */
module.exports = function (x) { return x === null; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibnVsbC5qcyIsInNvdXJjZXMiOlsibnVsbC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEBwYXJhbSAgeyp9IHggdmFsdWVcbiAqIEByZXR1cm4ge2Jvb2xlYW59IGlzTnVsbFxuICpcbiAqIEBzaW5jZSAzLjAuMFxuICogQG1lbWJlck9mIGlzXG4gKiBAZnVuYyBpc051bGxcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqICBpc051bGwobnVsbClcbiAqICAvLz0+IHRydWVcbiAqXG4gKiAgaXNOdWxsKHVuZGVmaW5lZClcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNOdWxsKHZvaWQgMClcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNOdWxsKHt9KVxuICogIC8vPT4gZmFsc2VcbiAqICBpc051bGwoJycpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzTnVsbCgxKVxuICogIC8vPT4gZmFsc2VcbiAqXG4gKi9cbm1vZHVsZS5leHBvcnRzID0geCA9PiB4ID09PSBudWxsXG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUF5QkEsTUFBTSxDQUFDLE9BQU8sR0FBRyxVQUFBLENBQUMsQ0FBQSxDQUFDLEFBQUcsU0FBQSxDQUFDLEtBQUssSUFBSSxHQUFBOyJ9